import React from "react";
import { Loader2 } from "lucide-react";
import { createAuthSession } from "@/lib/api";
import { toast } from "sonner";
import HppyfxMark from "@/components/HppyfxMark";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * Processes the #session_id=... fragment left by Emergent OAuth and exchanges
 * it server-side for an httpOnly session_token cookie.
 */
export default function AuthCallback({ onAuthed }) {
  const hasProcessed = React.useRef(false);

  React.useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      // Not an auth callback — bail
      onAuthed(null);
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const data = await createAuthSession(sessionId);
        // Clean URL immediately so hash is not retained
        window.history.replaceState({}, "", window.location.pathname);
        toast.success(`Welcome, ${data.user.name}`);
        onAuthed(data.user);
      } catch (err) {
        toast.error("Sign-in failed. Please try again.");
        window.history.replaceState({}, "", window.location.pathname);
        onAuthed(null);
      }
    })();
  }, [onAuthed]);

  return (
    <div
      className="min-h-screen bg-white flex items-center justify-center"
      data-testid="auth-callback-screen"
    >
      <div className="flex flex-col items-center gap-6">
        <HppyfxMark variant="default" className="h-10" />
        <div className="flex items-center gap-3 text-gray-700">
          <Loader2 className="w-5 h-5 animate-spin text-[#5E3BFF]" strokeWidth={1.5} />
          <span className="text-sm font-semibold">Signing you in...</span>
        </div>
      </div>
    </div>
  );
}
